import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-member_card",
  "use": "icon-member_card-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-member_card\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M167 217v128.153c0 9.94-8.059 18-18 18s-18-8.06-18-18V199c0-9.941 8.059-18 18-18h448c9.941 0 18 8.059 18 18v146.153c0 9.94-8.059 18-18 18s-18-8.06-18-18V217H167z\" p-id=\"12166\" />\n  <path d=\"M167 364v509h690V364H167z m-18-36h726c9.941 0 18 8.059 18 18v545c0 9.941-8.059 18-18 18H149c-9.941 0-18-8.059-18-18V346c0-9.941 8.059-18 18-18z\" p-id=\"12167\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/member_card.svg
// module id = VPEo
// module chunks = 17